<template>
  <main class="mt-0">
    <Login :options="{
      password: { enabled: true, url: '/login' },
      magicLink: { enabled: true, url: '/magic-links' },
    }" :userType="'user'" @onSubmit="onSubmit" @onError="onError" />
  </main>
</template>

<script>
import Login from '@components/shared/login/Login.vue';

export default {
  components: { Login },
  inject: ['locale'],

  methods: {
    onSubmit(response) {
      // Valores por default: Magic Link
      let title = 'Enlace enviado';
      let text = 'Te hemos enviado un Magic Link a tu correo. Revisa tu bandeja de entrada para continuar.';

      if (response.type === 'password') {
        // Login con contraseña exitoso
        title = 'Inicio de sesión exitoso';
        text = 'Estás entrando a tu cuenta de Finova!.';

        setTimeout(() => {
          window.location.href = '/app';
        }, 1250);
      }

      this.$swal.fire({
        icon: 'success',
        title: title,
        text: text,
        confirmButtonColor: "#029CDF",
      });
    },

    onError() {
      this.$swal.fire({
        icon: 'error',
        title: 'No se pudo iniciar sesión',
        text: 'Ocurrió un error al procesar tu inicio de sesión. Verifica tus datos e inténtalo de nuevo.'
      });
    }
  }
};
</script>
